import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { OnboardingProcessStepSchema } from "../dtos";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";
import { makeUpdateInputSchema } from "../utils/zod-utils/makeUpdateInputSchema";

const c = initContract();

export const onboardingProcessStepsContract = c.router({
  list: {
    method: "GET",
    path: "/onboarding/process-steps",
    responses: {
      200: OnboardingProcessStepSchema.array(),
    },
    summary: "List the requesting company's onboarding process steps",
  },

  addDefaults: {
    method: "POST",
    path: "/onboarding/process-steps/add-defaults",
    body: z.object({}),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
    summary:
      "Add the default process steps matching the company's onboarding activity type, if it has none yet",
  },

  create: {
    method: "POST",
    path: "/onboarding/process-steps",
    body: makeCreateInputSchema(OnboardingProcessStepSchema),
    responses: {
      201: OnboardingProcessStepSchema,
      400: z.object({ message: z.string() }),
    },
    summary: "Create an onboarding process step",
  },

  update: {
    method: "PATCH",
    path: "/onboarding/process-steps/:id",
    body: makeUpdateInputSchema(OnboardingProcessStepSchema),
    responses: {
      200: OnboardingProcessStepSchema,
      400: z.object({ message: z.string() }),
    },
    summary: "Update an onboarding process step",
  },

  delete: {
    method: "DELETE",
    path: "/onboarding/process-steps/:id",
    body: z.object({}).optional(),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
    summary: "Delete an onboarding process step",
  },

  bulkDelete: {
    method: "DELETE",
    path: "/onboarding/process-steps/bulk/delete",
    body: z.object({ ids: z.string().uuid().array() }),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
    summary: "Delete multiple onboarding process steps for the requesting company",
  },

  getValidation: {
    method: "GET",
    path: "/onboarding/process-steps/validation",
    responses: {
      200: z.object({ duplicateIds: z.string().array() }),
    },
    summary:
      "Get the validation result (duplicated ids) for the requesting company's onboarding process steps",
  },
});
